<template lang="pug">
  .ct-tooltip.shadowBox
    span
      p.tooltip-title {{label}}
      p(v-for='(entry, i) in getSubtitleEntries && getSubtitleEntries')
        span
        a.key.black {{entry.value}}
      hr
      p(v-for='(entry, i) in getMainEntries && getMainEntries')
        span
        a.key.black {{entry.label}}
        a.value.black {{entry.value}}
      hr(v-if='hasSecondarySection')
      p(v-for='(entry, i) in getMainEntries && getSecondaryEntries')
        span
        a.key.black {{entry.label}}
        a.value.black {{entry.value}}
      p.helpText(v-if='helpText') {{helpText}}
</template>

<script>

import formatter from '../helper/formatter'

export default {
  props: {
    contents: Object,
    currency: String
  },

  computed: {
    hasSecondarySection() {
      if (this.getMultipleEntriesByType('secondary').length > 0) return true
      else return false
    },
    label() {
      let title = this.getSingleEntryByType('title')
      return title
    },
    getSubtitleEntries() {
      return this.getMultipleEntriesByType('subtitle')
    },
    getMainEntries() {
      return this.getMultipleEntriesByType('main')
    },
    getSecondaryEntries() {
      return this.getMultipleEntriesByType('secondary')
    },
    helpText() {
      return this.contents.helpText
    }
  },
  methods: {
    getSingleEntryByType(type) {
      let index = this.contents.data.findIndex(e => e.type === type)
      let result = index !== -1 ? this.contents.data[index].content : ''
      return result
    },
    getMultipleEntriesByType(type) {
      let filteredData = this.contents.data.filter(function(entry) { return entry.type === type })
      let result = []
      filteredData.forEach(element => {
        result.push({ label: element.label, value: this.formatValue(element.content, element.format) })
      })
      return result
    },
    formatValue(value, type) {
      if (value === null || value === undefined) return 'N/A'
      if (type === 'currency') return formatter.getMoneyFormatedValue(value, this.currency)
      if (type === 'percentage') return value + '%'
      return value
    }
  }
}

</script>
<style scoped lang='scss'>
@import "~@/assets/sass/md/_chartTooltip.scss";
</style>



// WEBPACK FOOTER //
// src/core/charts/components/tooltip-standard.vue